import { Search } from 'lucide-react'
import { useCallback, useState } from 'react'
import { LayoutView } from '../../components/Layout/Layout'
import * as styled from '../../util/styled'
import { SearchTypesOptionBar, type SearchTypeOption, useSearchType } from './SearchTypeOptionsBar/SearchTypeOptionsBar'
import { WebAndNews } from './Results/WebAndNews/WebAndNews'
import { makeStringSearchParamHook } from '../../hooks/useSearchParam'

const Container = styled.div('max-w-screen-xl mx-auto p-4 pt-10')
const JumboSearchForm = styled.form('relative group transition-opacity')
const JumboSearchButton = styled.button<{ focused: boolean }>((props) => [`
  absolute h-full flex flex-row items-center right-0 top-0 rounded-[3em] px-3 gap-3 mr-4
  text-3xl text-brand opacity-30
`, { 'opacity-100': props.focused }])
const JumboSearchInput = styled.input<{ focused: boolean }>((props) => [`
  w-full rounded-lg py-3 px-5
  border-2 border-border-standby bg-surface-elevated text-2xl
  text-text-secondary
  placeholder:text-text-tertiary
  focus:outline-none
  focus:ring-0 focus:ring-brand-bg
`, { 'border-brand': props.focused }])
const SearchIcon = styled.component(Search)('w-5 h-5')
const JumboSearchTitle = styled.h2('font-semibold text-xl text-text-secondary mb-2')

const useSearchQuery = makeStringSearchParamHook('q')

export const SearchPage = () => {
  const [submittedSearchValue, setSubmittedSearchValue] = useSearchQuery('')
  const [searchValue, setSearchValue] = useState(submittedSearchValue)
  const [isFocused, setIsFocused] = useState(false)
  const [selectedSearchType, setSelectedSearchType] = useSearchType('all')
  const handleSubmit = useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setSubmittedSearchValue(searchValue)
  }, [searchValue, setSubmittedSearchValue])
  return (
    <LayoutView mainContent={(
      <Container>
        <JumboSearchTitle>Connect with authors, creators, and influencers</JumboSearchTitle>
        <JumboSearchForm
          onSubmit={handleSubmit}
        >
          <JumboSearchInput
            focused={isFocused}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
          <JumboSearchButton focused={isFocused}>
            <SearchIcon />
          </JumboSearchButton>
        </JumboSearchForm>
        <SearchTypesOptionBar
          selected={selectedSearchType as SearchTypeOption}
          onSelect={setSelectedSearchType}
        />
        {selectedSearchType === 'web' && <WebAndNews query={submittedSearchValue} />}
      </Container>
    )} />
  )
}